import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-background text-foreground gap-6">
      {/* Branded gradient text above (no circle, sizing/spacing as login guide) */}
      <div
        className="w-full max-w-[280px] h-[52px] bg-gradient-to-r from-primary to-tertiary shrink-0"
        style={{
          WebkitMaskImage: "url('/logos/pink_dolphin_text.png')",
          maskImage: "url('/logos/pink_dolphin_text.png')",
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
        }}
        role="img"
        aria-label="Pink Dolphin Tracker - Professional Trading Card Analytics"
      />
      {/* Larger spinner with dolphin in center (no circle around dolphin) */}
      <div className="relative">
        <svg
          className="animate-spin h-24 w-24 text-secondary"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <img
            src="/logos/pink_dolphin_logo.png"
            alt=""
            className="h-14 w-14 object-contain"
            aria-hidden
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;

